import Provider from './src/helper/context';

export const wrapRootElement = Provider;